import { clear, get, set } from "./local-storage";

const USER_CLINIC_LOCAL_STORAGE_KEY = "user_clinic";
export const setOnLocalStorage = (clinic) => set(USER_CLINIC_LOCAL_STORAGE_KEY, clinic);
export const getFromLocalStorage = () => get(USER_CLINIC_LOCAL_STORAGE_KEY);
export const clearOnLocalStorage = () => clear(USER_CLINIC_LOCAL_STORAGE_KEY);